module.exports = __webpack_public_path__ + "static/media/question.63be1e24.svg";